import type * as React from "react";

import { cx } from "../../lib/cx";
import s from "./Heading.module.css";

export type HeadingLevel = 1 | 2 | 3 | 4;
/** Tamaño visual, independiente del nivel semántico. */
export type HeadingSize = "display" | "xl" | "lg" | "md" | "sm";

const SIZE_POR_NIVEL: Record<HeadingLevel, HeadingSize> = { 1: "display", 2: "lg", 3: "md", 4: "sm" };

export interface HeadingProps extends React.ComponentPropsWithoutRef<"h1"> {
  /** Nivel semántico: qué `<hN>` se renderiza. */
  level?: HeadingLevel;
  /** Tamaño visual. Por default sale del nivel; se separa cuando el orden del documento y el peso visual no coinciden. */
  size?: HeadingSize;
  /** Un elemento distinto a `<hN>` (p. ej. `span` para un título que no entra en el árbol de encabezados). */
  as?: React.ElementType;
}

/** Título en Plus Jakarta Sans 600. `level` es el árbol del documento; `size` es lo que se ve. */
export function Heading({ level = 2, size, as, className, ...rest }: HeadingProps) {
  const Tag: React.ElementType = as ?? `h${level}`;
  return <Tag className={cx(s.heading, className)} data-size={size ?? SIZE_POR_NIVEL[level]} {...rest} />;
}
